import React, { useState, useEffect } from "react";
import { ExternalLink, Star, Download, Globe, ArrowRight } from "../components/Icons";
import { Reveal, Button, SectionHeading, PageGlow } from "../components/ui";

/* ─── Data ─── */
const PRODUCTS = [
  /* ── Mobile ── */
  {
    id: "kwik",
    icon: "📚",
    name: "KwiK",
    tagline: "Fun learning games for kids aged 4–11",
    desc: "An interactive kids learning app with lessons, quizzes, games, rewards and certificates across math, English, science and more — making education fun and engaging.",
    category: "mobile",
    platform: "Android",
    installs: "450K+",
    rating: "4.2",
    ratingCount: "1.5K",
    tags: ["Kids", "Education", "Android"],
    color: "emerald",
    url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.nm.premium",
    status: "live",
  },
  {
    id: "nbubble",
    icon: "💬",
    name: "nBubble",
    tagline: "Reply instantly with floating chat heads",
    desc: "Organizes incoming chat notifications into smart, customizable floating bubbles, so you can read and reply to WhatsApp, Messenger, Telegram, SMS and more without ever leaving your current app.",
    category: "mobile",
    platform: "Android",
    installs: "400K+",
    rating: "4.2",
    ratingCount: "1K",
    tags: ["Social", "Chat", "Android"],
    color: "emerald",
    url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.nm.stable",
    status: "live",
  },
  {
      id: "appsearch",
      icon: "🔍",
      name: "App Search",
      tagline: "The quickest way to open any app",
      desc: "A fast, lightweight app finder that searches installed apps with real-time results, single-tap launch, keyboard search action and recent history — ad-free and optimized for phones and tablets.",
      category: "mobile",
      platform: "Android",
      installs: "400K+",
      rating: "4.4",
      ratingCount: "675",
      tags: ["Utility", "Tool", "Android"],
      color: "emerald",
      url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.search",
      status: "live",
    },
  {
    id: "digits",
    icon: "🔢",
    name: "Digits",
    tagline: "Open apps with numeric shortcut codes",
    desc: "A lightweight launcher widget that opens your favorite apps from the home screen using simple numeric codes. Hide apps behind shortcuts, cut home-screen clutter, and launch in seconds.",
    category: "mobile",
    platform: "Android",
    installs: "50K+",
    rating: "4.4",
    ratingCount: "399",
    tags: ["Utility", "Tools", "Android"],
    color: "indigo",
    url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.digits&hl=en",
    status: "live",
  },
    {
      id: "mylog",
      icon: "📝",
      name: "MyLog",
      tagline: "Diary, notes & journal in one secure app",
      desc: "Capture daily memories, personal notes and journal entries in one place, protected with fingerprint, PIN or pattern lock. Fast search, a clean interface, and completely ad-free.",
      category: "mobile",
      platform: "Android",
      installs: "50K+",
      rating: "4.2",
      ratingCount: "391",
      tags: ["Diary", "Notes", "Android"],
      color: "indigo",
      url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.san",
      status: "live",
    },
  {
    id: "pokeme",
    icon: "⏱️",
    name: "Poke Me",
    tagline: "Ads-free drink water reminder & tracker",
    desc: "A minimalist hydration tracker that sends smart reminders, logs water intake with a single tap, and sets personalized daily goals to keep you hydrated — with zero ads.",
    category: "mobile",
    platform: "Android",
    installs: "40K+",
    rating: "4.4",
    ratingCount: "194",
    tags: ["Tools", "Health", "Android"],
    color: "violet",
    url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.pria",
    status: "live",
  },
    {
      id: "beam",
      icon: "💡",
      name: "Beam",
      tagline: "Bright LED flashlight with shake control",
      desc: "Turns your phone into an instant, bright LED flashlight with shake-to-toggle control and a home-screen widget. Lightweight, ad-free, and ready the moment you open it.",
      category: "mobile",
      platform: "Android",
      installs: "5K+",
      rating: "4.2",
      ratingCount: "81",
      tags: ["Tools", "Android"],
      color: "violet",
      url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.torch",
      status: "live",
    },
  {
    id: "1shop",
    icon: "🛒",
    name: "1Shop",
    tagline: "All your shopping websites in one app",
    desc: "Access the most popular online stores for your country from a single app, search products across multiple sites at once, add your own stores, and save favorites — no need for dozens of shopping apps.",
    category: "mobile",
    platform: "Android",
    installs: "50K+",
    rating: "4.6",
    ratingCount: "596",
    tags: ["Shopping", "E-commerce", "Android"],
    color: "emerald",
    url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.nm",
    status: "live",
  },
  {
    id: "apznotes",
    icon: "📙",
    name: "Apz Notes",
    tagline: "Beautiful notes, checklists & organization",
    desc: "A modern note-taking app with a rich-text editor, checklists, folders and tags, fast search, document scanner, voice notes, reminders and fingerprint lock — with dark mode and tablet support.",
    category: "mobile",
    platform: "Android",
    installs: "50K+",
    rating: "4.3",
    ratingCount: "187",
    tags: ["Notes", "Productivity", "Android"],
    color: "indigo",
    url: "https://play.google.com/store/apps/details?id=com.ram.chocolate.motivate.me",
    status: "live",
  },
  {
    id: "apzlock",
    icon: "🔒",
    name: "Apz Lock",
    tagline: "Lock apps with PIN, pattern or fingerprint",
    desc: "Secures private apps like WhatsApp, Instagram, gallery and banking apps with PIN, pattern or fingerprint authentication, preventing unauthorized access while staying fast and lightweight.",
    category: "mobile",
    platform: "Android",
    installs: "30K+",
    rating: "4.2",
    ratingCount: "60",
    tags: ["Privacy", "Security", "Android"],
    color: "violet",
    url: "https://play.google.com/store/apps/details?id=pt.nm",
    status: "live",
  },
  /*{
    id: "trackr",
    icon: "✅",
    name: "Trackr",
    tagline: "Habit, goal & wellness tracking",
    desc: "A science-backed habit tracker with streak tracking, goal forecasting, weekly reviews, and health metric integrations. Built on React Native with a Java backend for real-time sync across devices.",
    category: "mobile",
    platform: "Android · iOS",
    installs: "80K+",
    rating: "4.5",
    ratingCount: "4.1K",
    tags: ["Health", "Productivity", "React Native"],
    color: "rose",
    url: "https://play.google.com/store",
    status: "live",
  },
  {
    id: "fyndr",
    icon: "📍",
    name: "Fyndr",
    tagline: "Hyperlocal service discovery platform",
    desc: "Discover and book verified local service providers — electricians, plumbers, tutors, designers — with real-time availability, transparent pricing, and in-app escrow payments.",
    category: "mobile",
    platform: "Android · iOS",
    installs: "120K+",
    rating: "4.1",
    ratingCount: "7.9K",
    tags: ["Local Services", "Marketplace", "Geo"],
    color: "amber",
    url: "https://play.google.com/store",
    status: "live",
  },
  {
    id: "pulsecheck",
    icon: "❤️",
    name: "PulseCheck",
    tagline: "Health metrics monitoring & insights",
    desc: "A personal health dashboard integrating with wearables and manual logging for vitals, nutrition, sleep, and stress. AI-powered weekly health summaries highlight trends before they become problems.",
    category: "mobile",
    platform: "iOS",
    installs: "200K+",
    rating: "4.6",
    ratingCount: "11.3K",
    tags: ["Health", "Wearables", "iOS"],
    color: "red",
    url: "https://apps.apple.com",
    status: "live",
  },
  {
    id: "vaultpass",
    icon: "🔐",
    name: "VaultPass",
    tagline: "Zero-knowledge password manager",
    desc: "End-to-end encrypted password vault with biometric unlock, secure note storage, breach monitoring, and cross-device sync. AES-256 encryption with zero knowledge architecture — your data stays yours.",
    category: "mobile",
    platform: "Android · iOS",
    installs: "60K+",
    rating: "4.7",
    ratingCount: "2.9K",
    tags: ["Security", "Privacy", "E2E Encrypted"],
    color: "cyan",
    url: "https://play.google.com/store",
    status: "live",
  },*/
  /* ── Desktop ── */
  /*{
    id: "focusify",
    icon: "⏱️",
    name: "Focusify",
    tagline: "Pomodoro & deep work manager for macOS",
    desc: "A native macOS productivity app with smart Pomodoro sessions, focus scoring, website blocking, ambient soundscapes, and Notion/Linear integrations. Built with Swift for sub-1ms response times.",
    category: "desktop",
    platform: "macOS 12+",
    installs: "30K+",
    rating: "4.7",
    ratingCount: "1.8K",
    tags: ["Productivity", "macOS", "Swift"],
    color: "orange",
    url: "https://apps.apple.com/mac",
    status: "live",
  },
  {
    id: "quicknotes",
    icon: "📝",
    name: "QuickNotes Pro",
    tagline: "Native macOS note-taking with AI summaries",
    desc: "A lightning-fast native macOS note app with markdown support, global hotkey capture, folder organization, iCloud sync, and AI-powered summarization of long notes. Offline-first architecture.",
    category: "desktop",
    platform: "macOS 12+",
    installs: "25K+",
    rating: "4.5",
    ratingCount: "1.2K",
    tags: ["Notes", "macOS", "AI", "Swift"],
    color: "yellow",
    url: "https://apps.apple.com/mac",
    status: "live",
  },
  {
    id: "devlens",
    icon: "🔬",
    name: "DevLens",
    tagline: "API inspector & HTTP traffic debugger",
    desc: "A developer-grade macOS tool for inspecting, replaying, and stress-testing HTTP/HTTPS traffic. Supports GraphQL, gRPC, WebSocket streams, and JWT decoding. Loved by backend engineers.",
    category: "desktop",
    platform: "macOS 13+",
    installs: "15K+",
    rating: "4.8",
    ratingCount: "890",
    tags: ["DevTools", "API", "macOS", "Swift"],
    color: "teal",
    url: "https://apps.apple.com/mac",
    status: "live",
  },*/
  /* ── Web Platforms ── */
  {
    id: "aditirealty",
    icon: "🏠",
    name: "AditiRealty.com",
    tagline: "Quiet-luxury real estate — acquire, build, multiply",
    desc: "A production real estate platform for title-vetted plots, villas, houses, land and apartments, with end-to-end construction, bank-assisted EMI financing, and the Aditi Legal Shield.",
    category: "web",
    platform: "Web Platform",
    installs: "2L+ MAU",
    rating: "4.6",
    ratingCount: "Client",
    tags: ["Real Estate", "Next.js", "PostgreSQL"],
    color: "emerald",
    url: "https://aditirealty.com",
    status: "live",
  },
  {
      id: "airxsolar",
      icon: "❄️",
      name: "AirXSolar.com",
      tagline: "Cooling & solar e-commerce platform",
      desc: "An e-commerce platform for air conditioning and solar products — browse the latest cooling and solar solutions and get comfort delivered straight to your home.",
      category: "web",
      platform: "Web Platform",
      installs: "50K+ MAU",
      rating: "4.5",
      ratingCount: "Client",
      tags: ["E-commerce", "Next.js", "PostgreSQL"],
      color: "emerald",
      url: "https://www.airxsolar.com.au/",
      status: "live",
    },
  /*{
    id: "adhiguru",
    icon: "🎓",
    name: "AdhiGuru.com",
    tagline: "Live & recorded EdTech learning platform",
    desc: "A comprehensive EdTech platform for live cohort-based courses, self-paced video learning, certification pathways, and interactive quizzes. Integrated with Razorpay, Zoom, and AWS CloudFront for global CDN delivery.",
    category: "web",
    platform: "Web Platform",
    installs: "30K MAU",
    rating: "4.8",
    ratingCount: "Client",
    tags: ["EdTech", "Next.js", "Node.js"],
    color: "indigo",
    url: "https://adhiguru.com",
    status: "live",
  },*/
  /*{
    id: "tescobusiness",
    icon: "📊",
    name: "TescoBusiness.com",
    tagline: "Business management & operations suite",
    desc: "An all-in-one B2B SaaS covering invoicing, CRM pipeline, expense management, payroll, and team collaboration. Built for SMBs with multi-currency support and automated tax filing integrations.",
    category: "web",
    platform: "Web Platform",
    installs: "8K MAU",
    rating: "4.7",
    ratingCount: "Client",
    tags: ["Business SaaS", "CRM", "Finance"],
    color: "violet",
    url: "#",
    status: "live",
  },
  {
    id: "launchplex",
    icon: "🚀",
    name: "Launchplex.io",
    tagline: "SaaS launch analytics & growth intelligence",
    desc: "A growth analytics platform for SaaS founders — tracking acquisition funnels, churn cohorts, MRR/ARR trends, and feature adoption. Integrates with Stripe, Segment, and Mixpanel out of the box.",
    category: "web",
    platform: "Web Platform",
    installs: "5K MAU",
    rating: "4.8",
    ratingCount: "Client",
    tags: ["Analytics", "SaaS", "React", "Go"],
    color: "cyan",
    url: "#",
    status: "live",
  },*/

  /* ── Enterprise ── */
  /*{
    id: "coresync",
    icon: "🏭",
    name: "CoreSync ERP",
    tagline: "End-to-end enterprise resource planning",
    desc: "A multi-tenant ERP system covering procurement, inventory, manufacturing workflows, HR, and financial consolidation across multiple subsidiaries. Built on Java microservices with Kubernetes orchestration for 99.99% uptime.",
    category: "enterprise",
    platform: "Enterprise SaaS",
    installs: "Enterprise",
    rating: "4.9",
    ratingCount: "Client",
    tags: ["ERP", "Java", "Kubernetes", "Multi-tenant"],
    color: "rose",
    url: "#",
    status: "live",
  },
  {
    id: "fleetpulse",
    icon: "🚛",
    name: "FleetPulse",
    tagline: "Real-time fleet management & telematics",
    desc: "A enterprise fleet operations platform with GPS telematics, driver behavior scoring, predictive maintenance alerts, route optimization, and compliance reporting for 10K+ vehicles under management.",
    category: "enterprise",
    platform: "Enterprise SaaS",
    installs: "Enterprise",
    rating: "4.8",
    ratingCount: "Client",
    tags: ["Fleet", "IoT", "Real-time", "Go"],
    color: "amber",
    url: "#",
    status: "live",
  },*/
];

const TABS = [
  { id: "all",        label: "All",               count: PRODUCTS.length },
  { id: "mobile",     label: "Mobile (iOS/Android)", count: PRODUCTS.filter(p => p.category === "mobile").length },
  /*{ id: "desktop",    label: "Desktop (macOS)",    count: PRODUCTS.filter(p => p.category === "desktop").length },*/
  { id: "web",        label: "Web Platforms",      count: PRODUCTS.filter(p => p.category === "web").length },
  /*{ id: "enterprise", label: "Enterprise",         count: PRODUCTS.filter(p => p.category === "enterprise").length },*/
];

const COLOR_MAP = {
  emerald: { border: "border-emerald-500/25", grad: "from-emerald-500/30 to-teal-500/10", text: "text-emerald-600", badge: "bg-emerald-500/10 text-emerald-600 border-emerald-500/25" },
  indigo:  { border: "border-accent-500/25",  grad: "from-accent-500/30 to-blue-500/10",  text: "text-accent-600",  badge: "bg-accent-500/10 text-accent-600 border-accent-500/25"   },
  violet:  { border: "border-violet-500/25",  grad: "from-violet-500/30 to-purple-500/10", text: "text-violet-600", badge: "bg-violet-500/10 text-violet-600 border-violet-500/25"   },
  rose:    { border: "border-rose-500/25",    grad: "from-rose-500/30 to-pink-500/10",    text: "text-rose-600",    badge: "bg-rose-500/10 text-rose-600 border-rose-500/25"         },
  amber:   { border: "border-amber-500/25",   grad: "from-amber-500/30 to-orange-500/10", text: "text-amber-600",   badge: "bg-amber-500/10 text-amber-600 border-amber-500/25"      },
  red:     { border: "border-red-500/25",     grad: "from-red-500/30 to-rose-500/10",     text: "text-red-600",     badge: "bg-red-500/10 text-red-600 border-red-500/25"            },
  cyan:    { border: "border-cyan-500/25",    grad: "from-cyan-500/30 to-sky-500/10",     text: "text-cyan-600",    badge: "bg-cyan-500/10 text-cyan-600 border-cyan-500/25"         },
  orange:  { border: "border-orange-500/25",  grad: "from-orange-500/30 to-amber-500/10", text: "text-orange-600",  badge: "bg-orange-500/10 text-orange-600 border-orange-500/25"   },
  yellow:  { border: "border-yellow-500/25",  grad: "from-yellow-500/30 to-amber-500/10", text: "text-yellow-600",  badge: "bg-yellow-500/10 text-yellow-600 border-yellow-500/25"   },
  teal:    { border: "border-teal-500/25",    grad: "from-teal-500/30 to-emerald-500/10", text: "text-teal-600",    badge: "bg-teal-500/10 text-teal-600 border-teal-500/25"         },
};

function ProductCard({ product }) {
  const c = COLOR_MAP[product.color] || COLOR_MAP.emerald;
  const isMobile = product.category === "mobile";
  const isWeb = product.category === "web" || product.category === "enterprise";

  return (
    <article className="card-interactive group flex flex-col overflow-hidden h-full">
      <div className="p-6 flex-1">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className={"w-14 h-14 rounded-2xl bg-gradient-to-br " + c.grad + " border border-zinc-200 flex items-center justify-center text-3xl flex-shrink-0"}>
            {product.icon}
          </div>
          <div className="flex flex-col items-end gap-2">
            <span className={"px-2.5 py-1 rounded-full text-xs font-semibold border " + c.badge}>
              {product.platform}
            </span>
            <div className="flex items-center gap-1 text-amber-500">
              <Star size={12} />
              <span className="text-xs font-bold text-zinc-900">{product.rating}</span>
              <span className="text-zinc-500 text-xs">({product.ratingCount})</span>
            </div>
          </div>
        </div>

        {/* Info */}
        <h2 className="text-zinc-900 font-bold text-lg mb-1 tracking-tight">{product.name}</h2>
        <p className={"text-sm font-medium mb-3 " + c.text}>{product.tagline}</p>
        <p className="text-zinc-600 text-sm leading-relaxed mb-4">{product.desc}</p>

        {/* Tags */}
        <div className="flex flex-wrap gap-1.5 mb-4">
          {product.tags.map((tag) => (
            <span key={tag} className="px-2.5 py-1 rounded-lg text-xs text-zinc-600 bg-zinc-100 border border-zinc-200">
              {tag}
            </span>
          ))}
        </div>

        {/* Installs */}
        {(isMobile || isWeb) && (
          <div className="flex items-center gap-1.5 text-zinc-500 text-xs">
            {isMobile ? <Download size={12} className="text-emerald-600" /> : <Globe size={12} className="text-emerald-600" />}
            <span className={"font-semibold " + c.text}>{product.installs}</span>
            <span>{isMobile ? "installs" : "monthly active users"}</span>
          </div>
        )}
      </div>

      {/* Footer CTA */}
      <div className="border-t border-zinc-200 p-4">
        <a
          href={product.url}
          target="_blank"
          rel="noopener noreferrer"
          className={"flex items-center justify-center gap-2 w-full py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 border border-zinc-200 bg-white hover:bg-zinc-100 " + c.text}
        >
          View Product
          <ExternalLink size={14} className="group-hover:translate-x-0.5 transition-transform" />
        </a>
      </div>
    </article>
  );
}

function ProductSkeleton() {
  return (
    <div className="card p-6 h-full">
      <div className="flex items-start justify-between mb-4">
        <div className="skeleton w-14 h-14 rounded-2xl" />
        <div className="skeleton h-6 w-24 rounded-full" />
      </div>
      <div className="skeleton h-5 w-1/2 mb-3" />
      <div className="skeleton h-4 w-2/3 mb-4" />
      <div className="skeleton h-3 w-full mb-2" />
      <div className="skeleton h-3 w-5/6 mb-5" />
      <div className="flex gap-2">
        <div className="skeleton h-6 w-16 rounded-lg" />
        <div className="skeleton h-6 w-16 rounded-lg" />
      </div>
    </div>
  );
}

export default function EcosystemPage({ navigate }) {
  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(true);

  // Tasteful first-paint skeleton (visual only — no data/routing change)
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 450);
    return () => clearTimeout(t);
  }, []);

  const filtered = activeTab === "all"
    ? PRODUCTS
    : PRODUCTS.filter((p) => p.category === activeTab);

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative py-20 px-6 text-center overflow-hidden">
        <PageGlow />
        <div className="relative max-w-4xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Our Ecosystem"
              title="Products We Build & Ship"
              subtitle="A curated ecosystem of owned products and client systems — spanning mobile, desktop, web, and enterprise. Every product shipped in 15 days or less."
            />
          </Reveal>
        </div>
      </section>

      {/* Filter Tabs */}
      <div className="sticky top-16 z-30 bg-white/80 backdrop-blur-xl border-y border-zinc-200 px-6 py-3.5">
        <div className="max-w-7xl mx-auto">
          <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide" role="tablist" aria-label="Filter products">
            {TABS.map((tab) => {
              const active = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  role="tab"
                  aria-selected={active}
                  onClick={() => setActiveTab(tab.id)}
                  className={"relative flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition-all duration-200 border " + (
                    active
                      ? "bg-zinc-100 text-zinc-900 border-zinc-300"
                      : "text-zinc-600 hover:text-zinc-900 hover:bg-zinc-50 border-transparent"
                  )}
                >
                  {tab.label}
                  <span className={"text-xs px-1.5 py-0.5 rounded-md " + (active ? "bg-accent-500/20 text-accent-700" : "bg-zinc-100 text-zinc-500")}>
                    {tab.count}
                  </span>
                  {active && (
                    <span className="absolute left-3 right-3 -bottom-[7px] h-0.5 rounded-full bg-gradient-to-r from-accent-400 to-emerald-400" />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Grid */}
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {Array.from({ length: 6 }).map((_, i) => (
              <ProductSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {filtered.map((product, i) => (
              <Reveal key={product.id} delay={Math.min(i, 6) * 60}>
                <ProductCard product={product} />
              </Reveal>
            ))}
          </div>
        )}

        {!loading && filtered.length === 0 && (
          <div className="flex flex-col items-center text-center py-20">
            <div className="w-16 h-16 rounded-2xl bg-zinc-100 border border-zinc-200 flex items-center justify-center mb-5">
              <Globe size={28} className="text-zinc-400" />
            </div>
            <p className="text-zinc-900 font-semibold text-lg mb-1">Nothing here yet</p>
            <p className="text-zinc-500 text-sm max-w-sm">No products in this category yet — check back soon, or explore the other categories above.</p>
          </div>
        )}
      </section>

      {/* CTA */}
      <section className="border-t border-zinc-200 py-20 px-6 text-center">
        <Reveal className="max-w-2xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900 mb-3">Ready to add your product to this ecosystem?</h2>
          <p className="text-zinc-600 text-sm mb-7">We ship production-grade systems in 15 days. Let's build yours.</p>
          <Button size="lg" onClick={() => navigate("contact")}>
            Start Building
            <ArrowRight size={16} />
          </Button>
        </Reveal>
      </section>
    </div>
  );
}
